/**
 * Convert assessment response values into safe employer-facing text.
 *
 * Legacy assessments store strings or arrays. Permanent two-way interviews
 * store `{ text, turnIds }` so evaluation evidence remains traceable. React
 * cannot render that object directly, and turn IDs are internal linkage rather
 * than answer content.
 *
 * @param {*} answer Raw value from `response.answers[questionId]`.
 * @param {string} fallback Text shown when no displayable answer exists.
 * @returns {string} A render-safe answer without internal metadata.
 */
export function assessmentAnswerText(answer, fallback = '') {
  if (answer === null || answer === undefined || answer === '') return fallback;
  if (Array.isArray(answer)) {
    const values = answer
      .map((item) => assessmentAnswerText(item, ''))
      .filter(Boolean);
    return values.length ? values.join(', ') : fallback;
  }
  if (typeof answer === 'object') {
    for (const candidate of [answer.text, answer.answer, answer.value, answer.url]) {
      if (typeof candidate === 'string' && candidate.trim()) return candidate.trim();
      if (typeof candidate === 'number' || typeof candidate === 'boolean') return String(candidate);
    }
    return fallback;
  }
  return String(answer);
}

/** Find the evaluation row bound to one approved question/coverage goal. */
export function assessmentQuestionEvaluation(breakdown, question) {
  if (!Array.isArray(breakdown) || !question) return null;
  const questionId = String(question.id || '');
  const questionText = String(question.text || '');
  return breakdown.find((row) => {
    if (!row || typeof row !== 'object') return false;
    if (questionId && String(row.goalId || row.questionId || '') === questionId) return true;
    const evaluatedText = typeof row.question === 'string' ? row.question : '';
    return Boolean(
      questionText
      && (evaluatedText === questionText || evaluatedText.includes(questionText.slice(0, 50)))
    );
  }) || null;
}
